<template>
  <div>
    <b-row>
      <b-col cols="12">

        <b-card class=" mt-12 ">
          <b-row>
            <h3>
              <feather-icon icon="FilterIcon" size="18" class="mr-50" /> {{$t('Absence Roles')}}
            </h3>
          </b-row>
          <b-row>
            <b-col cols="3">
              <div class="demo-inline-spacing">
                <b-form-checkbox v-model="AbsentData.dependsOn" value="distance">
                  {{ $t('depends on distance') }}
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col cols="4">
              <b-form-group :label="$t('operator')" label-for="vi-devices-id">
                <v-select v-model="AbsentData.dependsOn_distance_operator"
                  :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                  :options="[...searchoperations]" :reduce="d => d.id" />
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group :label="$t('distance Km')" label-for="distance">
                <cleave id="dependsOn_distance" v-model="AbsentData.dependsOn_distance" class="form-control" :raw="false" :options="{
                  numeral: true,
                  numeralThousandsGroupStyle: 'thousand',
                }" placeholder="10,000" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="3">
              <div class="demo-inline-spacing">
                <b-form-checkbox v-model="AbsentData.dependsOn" value="duration">
                  {{ $t('depends on duration') }}
                </b-form-checkbox>

              </div>

            </b-col>
            <b-col cols="4">
              <b-form-group :label="$t('operator')" label-for="vi-devices-id">
                <v-select v-model="AbsentData.dependsOn_duration_operator"
                  :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                  :options="[...searchoperations]" :reduce="d => d.id" />

              </b-form-group>
            </b-col>


            <b-col cols="4">
              <b-form-group :label="$t('duration Hr')" label-for="dependsOn_duration">
                <cleave id="dependsOn_duration" v-model="AbsentData.dependsOn_duration" class="form-control" :raw="false"
                  :options="{
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                  }" placeholder="00:00" />
              </b-form-group>
            </b-col>

          </b-row>
          <b-row>
            <b-col cols="3">
              <div class="demo-inline-spacing">




                <b-form-checkbox v-model="AbsentData.dependsOn" value="campLeave">
                  {{ $t('depends on camp Leave') }}
                </b-form-checkbox>
              </div>
            </b-col>
          </b-row>
          <!-- duration   end  -->

        </b-card>

        <b-card class="border mt-12" v-if="$store.state.auth.userData.widgets.includes('DumpByStops')">
          <b-row class="mb-2">
            <h3>
              <feather-icon icon="TrashIcon" size="18" class="mr-50" /> {{$t('Dump By Stops')}}
            </h3>
          </b-row>
          <b-row>
            <b-col cols="4">
              <b-form-group :label="$t('Minimum Stop Time')" label-for="minStopTime">
                <cleave id="minStopTime" v-model="DumpByStopsData.minStopTime" class="form-control" :raw="false" :options="{numeral: true}" placeholder="1" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

      </b-col>

    </b-row>
    <b-row>
      <b-col cols="12">
        <!-- PERMISSION TABLE -->
        <b-card no-body class="border">

          <div v-if="requestPending" class="loading_page" style=" padding: 10px;">
            <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
          </div>

          <b-card-header class="p-1">
            <b-card-title class="font-medium-2">
              <feather-icon icon="CodesandboxIcon" size="18" />
              <span class="align-middle ml-50">{{ $t('select widgets to be hidden..') }}</span>
            </b-card-title>
          </b-card-header>


          <div class="m-2">

            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <label>{{ $t('Show') }}</label>
                <v-select v-model="perPage" :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
                <label>{{ $t('entries') }}</label>
              </b-col>

              <!-- Search -->
              <b-col cols="12" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search')" />
                </div>
              </b-col>
            </b-row>

          </div>
          <b-table striped responsive class="mb-0" :items="authRoles" :fields="fields">

            <template #head(list)="data">
              <b-form-checkbox @change="checkAll(data, $event)" />
            </template>

            <template #cell(name)="data">
              {{ data.item.name }}
            </template>

            <template #cell()="data">

              <b-form-checkbox :state="userRoles.includes(data.item.name) ? true : null"
                :checked="requestRoles.includes(data.item.name)" @change="change(data, $event)" />
            </template>
          </b-table>

          <div class="mx-2 mb-2">
            <b-row>

              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-muted">
                  {{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }} {{ $t('of') }} {{ dataMeta.of
                  }}
                  {{ $t('entries-users') }}
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

                <b-pagination v-model="currentPage" :total-rows="totalTable" :per-page="perPage" first-number
                  last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>

              </b-col>

            </b-row>
          </div>
        </b-card>
      </b-col>


      <b-col cols="12">
        <!-- Action Buttons -->
        <b-button type="submit" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="submit">
          {{ $t('Save Changes') }}
        </b-button>
      </b-col>


    </b-row>

  </div>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia, BPagination,
  BMediaAside,
  BMediaBody,
  BLink, BBadge,
  BImg,
  BTable, BFormCheckbox, BCardTitle, BCardHeader, BCollapse
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import { ref, computed, watch } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import permissionsStoreModule from '@/views/modules/user/users-edit/permissions/permissionsStoreModule'
import usePermissions from '@/views/modules/user/users-edit/permissions/usePermissions'
import UsersFilter from '@/views/modules/user/users-edit/permissions/UsersFilter'
import { OrbitSpinner } from 'epic-spinners'
import filters from "@/views/modules/Utils/filters";

import { saveHiddenWidgets } from './Services'
import axios from '@/libs/axios'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
export default {
  components: {
    BButton, BForm, BImg, BFormFile,
    BFormGroup, BFormInput, BRow,
    BCol, BAlert, BCard, BCardText, BBadge,
    BMedia, BMediaAside, BMediaBody, vSelect, BPagination,
    BLink, BTable, BFormCheckbox, BCardTitle, BCardHeader, UsersFilter,
    OrbitSpinner, Cleave,
    BCollapse, ToggleCollapse
  },
  directives: {
    Ripple,
  },
  props: {
    user: {
      type: Number,
      required: true
    },
  },

  setup(props, { root, emit }) {

    const USERS_PERMISSION_APP_STORE_MODULE_NAME = 'app-permission'

    if (!store.hasModule(USERS_PERMISSION_APP_STORE_MODULE_NAME))
      store.registerModule(USERS_PERMISSION_APP_STORE_MODULE_NAME,
        permissionsStoreModule)


    const authRoles = ref([])
    const userRoles = ref([])

    const requestRoles = ref([])

    const AbsentData = ref({
          dependsOn: [],
          dependsOn_distance_operator: "",
          dependsOn_duration_operator: "",
          dependsOn_distance: 1,
          dependsOn_duration: ""
    });

    const DumpByStopsData = ref({
      minStopTime:1
    })


    const { perPage, perPageOptions, searchQuery, currentPage, totalTable, dataMeta } = usePermissions()

    const filter = ref({})

    watch([currentPage, perPage, searchQuery], () => {
      filter.value = {
        ...(searchQuery.value && { q: searchQuery.value })
      }

      fetchData()
    })



    const requestPending = ref(false)

    const fetchData = () => {
      requestPending.value = true

      store.dispatch('app-permission/userGetLinked', {
        length: perPage.value,
        page: currentPage.value,
        user: store.state.auth.userData.id,
        type: 'widget',
        ...filter.value
      })
        .then(response => {

          requestPending.value = false
          const { total, data } = response.data.data
          //console.log('all data is ', data.value)
          totalTable.value = total
          authRoles.value = data
        })
        .catch(res => requestPending.value = false)
    }

    fetchData()



    const getDashSettings = () => {

      return new Promise((resolve, reject) => {
        axios.get(`dashboard/getUserSettings`)
          .then(res => {

            requestRoles.value = res.data.hiddenWidgets;
            AbsentData.value = res.data.widgets.Devices.Absent;

            if(res.data.widgets.DumpByStops != undefined){
              DumpByStopsData.value = res.data.widgets.DumpByStops
            }

          })
          .catch(error => reject(error))
      })
    }
    getDashSettings();



    const fields = ['name', 'list']


    const submit = () => {
      requestPending.value = true

      let postedData = {
        "hiddenWidgets": requestRoles.value,
        "widgets": {
          "Devices": {
            "Absent": AbsentData.value
          }
        }
      }

      if(DumpByStopsData.value != undefined){
        postedData.widgets.DumpByStops = DumpByStopsData.value;
      }

      saveHiddenWidgets(postedData
      ).then((res) => {
        //store.dispatch('auth/restShowWidgets',requestRoles.value)
        requestPending.value = false
        toaster('user roles updated successfully', 'success', 'success')

      }).catch(reason => {
        requestPending.value = false
        toaster('Error Happened', 'danger', 'Error')
      })



    }




    /**
     * check all
     * @param data
     * @param value
     */
    const checkAll = (data, value) => {
      if (value) requestRoles.value = authRoles.value.map((v) => v.name)
      else requestRoles.value = []
    }



    /**
     * change one
     * @param data
     * @param value
     */
    const change = (data, value) => {
      const index = requestRoles.value.indexOf(data.item.name);
      if (value && index === -1) requestRoles.value.push(data.item.name)
      else requestRoles.value.splice(index, 1)
    }


    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }
    const searchoperations = ref([


      {
        id: ">",
        name: 'greater than'
      },
      {
        id: "<",
        name: "less than"
      },
      {
        id: "=",
        name: "equal "
      }

    ]);

    return {
      requestPending,

      authRoles,
      userRoles,
      perPage,
      perPageOptions,
      currentPage,
      searchQuery,
      totalTable,
      dataMeta,
      change,
      fields,
      checkAll,
      submit,
      fetchData,
      requestRoles,

      //////set data ///

      saveHiddenWidgets,
      getDashSettings,
      AbsentData,
      DumpByStopsData,
      searchoperations
    }
  },
}
</script>
